<template>
  <div class="container" id="profile_section">
    <div class="row">
      <div class="col-12 mb-3">
        <div v-if="profile.status == 1" v-show="profile.reg_status != 'complete' && profile.reg_status != null" class="regProgress">
          <h3 class="register-step completed">Step 1 <br> REGISTERED</h3>
          <i class="fas fa-lg fa-solid fa-arrow-right arrow completed"></i>
          <h3 :class="['register-step', { 'completed': profile.reg_status == 'tour_finished' || profile.reg_status == 'timezone_set' }]">Step 2 <br> SELECT TIMEZONE</h3>
          <i :class="['fas', 'fa-lg', 'fa-solid', 'fa-arrow-right', 'arrow', { 'completed': profile.reg_status == 'tour_finished' || profile.reg_status == 'timezone_set'  }]"></i>
          <h3 :class="['register-step', { 'completed': profile.reg_status == 'tour_finished' || profile.reg_status == 'timezone_set'  }]">Step 3 <br> COMPLETED</h3>
          <div v-if="profile.reg_status == 'tour_finished'">
            <button @click="closeNotif" class='register-close'>
              <i class="fas fa-lg fa-solid fa-times-circle"></i>
            </button>
          </div>

        </div>

        <div class="card mt-3">
          <h5 class="card-header">
            <i class="far fa-user-circle"></i> Account Profile
          </h5>

          <div v-if="this.$store.state.preFlightData !== null">
            <b-alert show variant="danger" class="text-center">
              <h3 v-text="this.$store.state.preFlightData.message"></h3>
            </b-alert>
          </div>

          <div v-if="profile.status == 1">
            <div class="card-body">
              <div class="form-group row">
                <label for="first_name" class="col-lg-3 col-form-label"
                >Name</label
                >
                <div class="col-lg-4 mb-1">
                  <input
                    type="text"
                    v-model="profile.first_name"
                    class="form-control"
                    id="first_name"
                    placeholder="First Name"
                    @keyup="checkFormValid($event)"
                    required
                  />
                  <small
                    v-if="errors.first_name != ''"
                    v-text="errors.first_name"
                    class="text-danger"
                  ></small>
                </div>
                <div class="col-lg-4 mb-1">
                  <input
                    type="text"
                    v-model="profile.last_name"
                    class="form-control"
                    id="last_name"
                    placeholder="Family Name"
                    @keyup="checkFormValid($event)"
                    required
                  />
                  <small
                    v-if="errors.last_name != ''"
                    v-text="errors.last_name"
                    class="text-danger"
                  ></small>
                </div>
                <label for="staticEmail" class="col-lg-3 col-form-label"
                >User/Screen Name</label
                >
                <div class="col-lg-4 mb-1">
                  <input
                    type="text"
                    v-model="profile.user_name"
                    class="form-control"
                    id="user_name"
                    placeholder="User Name"
                    @keyup="checkFormValid($event)"
                    required
                  />
                  <small
                    v-if="errors.user_name != ''"
                    v-text="errors.user_name"
                    class="text-danger"
                  ></small>
                </div>
              </div>

              <div class="form-group row">
                <label for="staticEmail" class="col-lg-3 col-form-label"
                >Email</label
                >
                <div class="col-lg-6 mb-1">
                  <input
                    type="email"
                    v-model="profile.email"
                    class="form-control"
                    id="email"
                    @keyup="checkFormValid($event)"
                  />
                  <small
                    v-if="errors.email != ''"
                    v-text="errors.email"
                    class="text-danger"
                  ></small>
                </div>
              </div>

              <div class="form-group row">
                <label for="UTCOffset" class="col-lg-3 col-form-label"
                >Timezone Offset (hours)</label
                >
                <div class="col-lg-9 mb-1">
                  <div v-if="profile.timezoneOffsetH === null">
                    <h3 class="text-danger">
                      Set your timezone
                      <small>Then press the update profile submit button</small>
                    </h3>
                  </div>
                  <timezone-select :profile="profile" />
                </div>
              </div>

              <div class="form-group row mb-1">
                <label class="col-lg-3 col-form-label">Profile Picture</label>
                <div class="col-lg-6 mb-1">
                  <b-button @click="$bvModal.show('modal-profile-picture')"
                  >Upload</b-button
                  >
                </div>
              </div>
              <div class="form-group row mb-1">
                <label class="col-lg-3 col-form-label" />
                <div class="col-lg-6 mb-1">
                  <img class="profilePic" v-if="this.$store.state.profile.profile_image != null" :src="this.$store.state.profile.profile_image" alt="Avatar">
                  <img class="profilePic" v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
                </div>
              </div>

              <div v-if="profile.is_coach">

                <div class="form-group row">
                  <label for="Summary" class="col-lg-3 col-form-label">
                    Coach Summary <small style="font-size: 70%">({{profile.summary?.length ?? 0}}/255)</small>
                  </label>
                  <div class="col-lg-6 mb-1">
                    <input
                      type="text"
                      v-model="profile.summary"
                      class="form-control"
                      id="summary"
                      maxlength="255"
                      placeholder="Enter a short summary about yourself"
                      @keyup="checkFormValid($event)"
                    />
                  </div>
                </div>


                <div class="form-group row">
                  <label for="expertise" class="col-lg-3 col-form-label">
                    Coach Expertise
                    <small style="font-size: 70%">({{profile.expertise?.length ?? 0}}/255)</small>
                  </label>
                  <div class="col-lg-6 mb-1">
                    <input
                      class="form-control"
                      v-model="profile.expertise"
                      type="text"
                      id="expertise"
                      maxlength="255"
                      placeholder="Enter your key areas of expertise as a coach"
                      @keyup="checkFormValid($event)"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label">Social links</label>
                  <div class="col-lg-6 mb-2">
                    <input
                      class="form-control"
                      v-model="profile.linkedin"
                      type="text"
                      id="expertise"
                      placeholder="Linkedin"
                    />
                    <input
                      class="form-control mt-2"
                      v-model="profile.facebook"
                      type="text"
                      id="expertise"
                      placeholder="Facebook"
                    />
                    <input
                      class="form-control mt-2"
                      v-model="profile.instagram"
                      type="text"
                      id="expertise"
                      placeholder="Instagram"
                    />
                    <input
                      class="form-control mt-2"
                      v-model="profile.twitter"
                      type="text"
                      id="expertise"
                      placeholder="Twitter"
                    />
                    <input
                      class="form-control mt-2"
                      v-model="profile.tiktok"
                      type="text"
                      id="expertise"
                      placeholder="Tiktok"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group row mb-1">
                <label for="password" class="col-lg-3 col-form-label"
                >Change Password</label
                >
                <div class="col-lg-4">
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                    autocomplete="new-password"
                    @change="checkFormValid($event)"
                  />
                  <small
                    v-if="errors.password != ''"
                    v-text="errors.password"
                    class="text-danger"
                  ></small>
                </div>
                <div class="col-lg-4">
                  <input
                    type="password"
                    v-model="password_confirm"
                    class="form-control mb-1"
                    id="password_confirm"
                    placeholder="Confirm Password"
                    autocomplete="new-password"
                    @change="checkFormValid($event)"
                  />
                </div>
              </div>

              <p>
                <small
                >* Enter new password to change it, or leave it blank to
                  keep.</small
                >
              </p>

              <hr />

              <div class="form-group row">
                <label class="col-lg-3 col-form-label">Notifications</label>
                <div class="col-lg-6 mb-1">
                  <b-form-checkbox-group
                    v-model="notifications_selected"
                    :options="notifications_options"
                    stacked
                    switches
                    @change="notificationUpdate"

                  >
                  </b-form-checkbox-group>
                </div>
              </div>
            </div>

            <div class="card-footer bg-transparent text-center">
              <div
                v-if="errors.profile != ''"
                class="mb-2"
                :class="update_class"
              >
                <small v-html="errors.profile"></small>
              </div>
              <button
                type="button"
                class="btn"
                :class="btn_update_class"
                @click="updateProfile($event)"
                :disabled="!disableSubmit"
              >
                <i class="fas" :class="btn_update_icon"></i> Update Profile
              </button>
            </div>
          </div>
          <div v-else class="text-center gold m-5">
            <i class="fas fa-atom fa-spin fa-2x"></i>
          </div>
        </div>
      </div>
      <data-streams :profileid="this.$store.state.session_id" />

      <div class="col-12 mb-3">
        <div class="card mt-3">
          <h5 class="card-header">
            <i class="fas fa-file-invoice-dollar"></i> Subscriptions
          </h5>
          <div class="card-body text-center">
            <a href="/payments/subscriptions" class="btn btn-outline-primary">
              <i class="far fa-credit-card"></i> Manage Subscriptions
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="card mt-3">
          <h5 class="card-header">
            <i class="fas fa-download"></i> Download your data
          </h5>
          <div class="card-body text-center">
            <div class="d-flex justify-content-center" style="gap: 12px">
              <DownloadCSVButton
                v-if="profile.id"
                :userid="profile.id"
                class_style="btn btn-sm btn-outline-primary"
                text="Download Data"
              />

              <DownloadRemoteCSVButton text="Download Daily Log"></DownloadRemoteCSVButton>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-profile-picture"
        title="Profile Picture"
        ref="modal-profile-picture"
        ok-only
        ok-title="Update"
        @ok="crop()"
        @close="reset()"
        no-close-on-backdrop
      >
        <b-form-file
          type="file"
          ref="file"
          accept="image/*"
          @change="loadImage($event)">
        </b-form-file>
        <hr v-if="image.src !== null">
        <cropper
          ref="cropper"
          class="upload-example-cropper"
          :src="image.src"
          :stencil-props="{
						aspectRatio: 1 / 1,
					}"
          :canvas="{
						height: 256,
						width: 256,
					}"
        />
      </b-modal>

    </div>
    <!-- ./row -->
  </div>
</template>

<script>
import axios from "axios";
import DataStreams from "../components/DataStreams.vue";
import TimezoneSelect from "../components/TimezoneSelect.vue";
import DownloadCSVButton from '../components/DownloadCSVButton.vue';

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import DownloadRemoteCSVButton from "@/components/DownloadRemoteCSVButton";

export default {
  name: "profile",
  components: {
    DownloadRemoteCSVButton,
    Cropper,
    DataStreams,
    TimezoneSelect,
    DownloadCSVButton,
  },
  data() {
    return {
      image: {
        src: null,
        type: null,
      },
      btn_update_class: "btn-secondary",
      btn_update_icon: "fa-pen",
      disableSubmit: false,
      errors: {
        email: "",
        first_name: "",
        last_name: "",
        user_name: "",
        password: "",
        profile: "",
        profile_image: '',
      },
      notifications_options: [
        {
          text: "Email me to fill out my daily Focus Log if I haven't completed it before midday.",
          value: "feelings_log",
        },
        {
          text: "Email me when a user posts a message in the challenge chat.",
          value: "challenge_chat",
        }
      ],
      notifications_selected: [],
      password: "",
      password_confirm: "",
      update_class: "gold",
      finalBlob: null,
      base64data: null,
    };
  },
  methods: {
    getMimeType(file, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4);
      let header = "";
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16);
      }
      switch (header) {
        case "89504e47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
          return "image/jpeg";
        default:
          return fallback;
      }
    },
    crop() {
      let _this = this;
      const { canvas } = this.$refs.cropper.getResult();

      canvas.toBlob((blob) => {
        // Do something with blob: upload to a server, download and etc.
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
          _this.base64data = reader.result;
          _this.finalBlob = blob;
          _this.updateProfileImage();
        }
      }, this.image.type);
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      const { files } = event.target;

      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        const blob = URL.createObjectURL(files[0]);
        const reader = new FileReader();

        reader.onload = (e) => {
          this.image = {
            src: blob,
            type: this.getMimeType(e.target.result, files[0].type),
          };
        };
        reader.readAsArrayBuffer(files[0]);
      }
    },
    destroyed() {
      // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.image.src) {
        URL.revokeObjectURL(this.image.src);
      }
    },

    checkPassword() {
      if (this.password != this.password_confirm) {
        this.errors.password = "Passwords do not match!";
        return false;
      } else {
        this.errors.password = "";
        return true;
      }
    },
    checkEmail() {
      let _this = this;
      var is_valid = false;
      if (!this.validEmail(this.profile.email)) {
        this.errors.email = "A valid Email is required";
      } else {
        this.errors.email = "";
        is_valid = true;
      }

      if (is_valid == true) {
        // check if unique email
        let params = new URLSearchParams();
        params.append("token", _this.$store.state.session_id);
        params.append("email", _this.profile.email);

        axios({
          url: _this.$store.state.api_url + "emailCheck",
          params: params,
        })
          .then(function(response) {
            if (response.data === null) {
              _this.errors.email = "Email is already in use";
            } else {
              _this.errors.email = "";
            }
          })
          .catch(function() {});
      }
    },
    checkUsername() {
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("user_name", _this.profile.user_name);

      axios({
        url: _this.$store.state.api_url + "userNameCheck",
        params: params,
      })
        .then(function(response) {
          if (response.data === null) {
            _this.errors.user_name = "Username is already in use";
          }
        })
        .catch(function() {});
    },
    checkFormValid(e) {
      console.log("checkFormValid");
      var required = e.target.required;
      var id = e.target.id;
      var val = e.target.value;
      const errors = Object.keys(this.errors);

      /* set errors */
      this.errors.profile = "";
      for (const key of errors) {
        if (key === id && required == true) {
          if (val === "") {
            this.errors[key] = key + " is required";
          } else this.errors[key] = "";
        }

        if (key === "user_name") {
          this.checkUsername();
        } else if (key === "email") {
          this.checkEmail();
        } else if (key === "password" || key === "password_confirm") {
          this.checkPassword();
        }
      }

      var form_is_valid = true;
      for (const obj of Object.entries(this.errors)) {
        if (obj[1] !== "") {
          form_is_valid = false;
          break;
        }
      }

      if (form_is_valid == true) {
        this.disableSubmit = true;
        this.btn_update_class = "btn-success";
        this.btn_update_icon = "fa-hand-point-right";
      } else {
        this.disableSubmit = false;
        this.btn_update_class = "btn-secondary";
        this.btn_update_icon = "fa-pen";
      }

      return form_is_valid;
    },
    closeNotif() {
      let _this = this;

      let params = new URLSearchParams();
      params.append('token', _this.$store.state.session_id);
      params.append('reg_status', 'complete');

      axios({
        url: _this.$store.state.api_url + "regStatusUpdate",
        params: params,
      })
        .then(function(response) {
          if (response.data.status == 1) {
            _this.profile.reg_status = 'complete';
          } else {
            console.log("Response error");
          }
        })
        .catch(function() {});
    },
    notifigationsGet() {
      let _this = this;
      let params = new URLSearchParams();

      params.append("token", _this.$store.state.session_id);
      axios({
        url: _this.$store.state.api_url + "user_notifigation_settings_Get",
        params: params,
      })
        .then(function(response) {
          console.log(response.data.notifications);
          if (response.data.notifications['challenge_chat'] == 0) delete response.data.notifications['challenge_chat'];
          if (response.data.notifications['feelings_log'] == 0) delete response.data.notifications['feelings_log'];
          console.log(response.data.notifications);
          _this.notifications_selected = Object.keys(
            response.data.notifications
          );

        })
        .catch(function() {});
    },
    notificationUpdate() {
      this.disableSubmit = true;
      this.btn_update_class = "btn-success";
      this.btn_update_icon = "fa-hand-point-right";
    },
    updateProfile(e) {
      console.log('updateProfile...');
      if (this.checkPassword == false) return false;
      let _this = this;
      var form_is_valid = this.checkFormValid(e);
      console.log(form_is_valid);
      if (form_is_valid === false) return false;
      this.update_class = 'gold';
      this.errors.profile = '<i class="fas fa-atom fa-spin fa-2x"></i>';
      let params = new URLSearchParams();
      params.append('token', _this.$store.state.session_id);
      params.append('first_name', _this.profile.first_name);
      params.append('last_name', _this.profile.last_name);
      params.append('user_name', _this.profile.user_name);
      params.append('email', _this.profile.email);
      params.append('timezoneOffsetH', _this.profile.timezoneOffsetH);
      params.append('password', _this.password);
      params.append('notifications', _this.notifications_selected);
      params.append('summary', _this.profile.summary);
      params.append('expertise', _this.profile.expertise);
      params.append('linkedin', _this.profile.linkedin);
      params.append('facebook', _this.profile.facebook);
      params.append('instagram', _this.profile.instagram);
      params.append('twitter', _this.profile.twitter);
      params.append('tiktok', _this.profile.tiktok);

      console.log(_this.notifications_selected);

      axios({
        method: "post",
        url: _this.$store.state.api_url + "userUpdate",
        params: params,
      })
        .then(function(response) {
          _this.errors.profile = response.data.message;

          if (response.data.status == 1) {
            if (response.data.firstTZ == 'true') {
              _this.$router.push("/dashboard");
            }
            _this.disableSubmit = false;
            _this.btn_update_class = "btn-secondary";
            _this.btn_update_icon = "fa-pen";

            _this.$store.commit("profileSet", response.data);

            if (_this.$store.state.preFlightData.post_update !== null) {
              _this.$store.commit("preFlightDataSet", null);
              _this.$router.push("/dashboard");
            }
          } else {
            _this.update_class = response.data.class;
            console.log("Response error");
          }
        })
        .catch(function() {});
    },
    updateProfileImage() {
      let _this = this;

      let post = new FormData();
      let params = new URLSearchParams();

      params.append('token', _this.$store.state.session_id);

      if (_this.finalBlob != null) {
        post.append('profile_image', _this.finalBlob);
      }
      _this.destroyed();
      _this.reset();


      axios({
        method: "post",
        url: _this.$store.state.api_url + "userProfileImageUpdate",
        params: params,
        data: post,
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "multipart/form-data"
        }
      })
        .then(function(response) {
          _this.errors.profile = response.data.message;

          if (response.data.status == 1) {
            _this.disableSubmit = false;
            _this.btn_update_class = "btn-secondary";
            _this.btn_update_icon = "fa-pen";

            _this.$store.commit("profileSet", response.data);

            if (_this.$store.state.preFlightData.post_update !== null) {
              _this.$store.commit("preFlightDataSet", null);
              _this.$router.push("/dashboard");
            }
          } else {
            _this.update_class = response.data.class;
            console.log("Response error");
          }
        })
        .catch(function() {});
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var val = re.test(email);
      console.log(email + ":" + val);
      return val;
    },
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    active_profile() {
      return this.$store.getters.profileGet;
    },
    user_level() {
      return this.active_profile.level;
    },
  },
  created: function() {},
  mounted: function() {
    this.notifigationsGet();
  },
  watch: {
    "profile.timezoneOffsetH"(a, b) {
      if (b !== "undefined") {
        console.log("W:" + a + ":" + b);
        this.disableSubmit = true;
      }
    },
  },
};
</script>

<style scoped>
.expertbox {
  width: 300px;
}

.profilePic {
  width: 64px;
  height: 64px;
  border-radius: 100%;
}

.regProgress {
  width: 100%;
  margin-top: 20px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  padding-left: 2%;
  padding-right: 2%;
  border-radius: 5px;
}

.register-step {
  font-size: 24x; /* Default font size */
}

.register-close {
  position: absolute;
  top: 20px;
  right: 15px;
  background-color: inherit;
  border: none;
  outline: none;
}

.arrow {
  padding-left: 5%;
  padding-right: 5%;
}

@media (max-width: 767px) {
  .register-step {
    font-size: 14px; /* Adjusted font size for smaller viewports */
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .register-step {
    font-size: 20px; /* Adjusted font size for medium viewports */
  }
}

.completed {
  color: #D1AF60;
}

.incomplete {
  color: red;
}

</style>
